import { render, staticRenderFns } from "./customerGroup.vue?vue&type=template&id=41c69d9b&scoped=true"
import script from "./customerGroup.vue?vue&type=script&lang=js"
export * from "./customerGroup.vue?vue&type=script&lang=js"
import style0 from "./customerGroup.vue?vue&type=style&index=0&id=41c69d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c69d9b",
  null
  
)

export default component.exports